import {createContext} from 'react'


const UserContext = createContext({  
    name : "",
    image : "",
    editProfile : () => {},
});

export default UserContext;
